import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IomService } from 'src/app/services/iom.service';

@Component({
  selector: 'app-proposal-update',
  templateUrl: './proposal-update.component.html',
  styleUrls: ['./proposal-update.component.css']
})

export class ProposalUpdateComponent implements OnInit {
  isLoadCreateProposal = true;
  isLoadUploadExcel = false;
  isLoadTextConf = false;
  isFDS: boolean = false;
  DisableUpload: boolean = false;
  DisableCreate: boolean = false;
  instanceType: any;
  isLoadMapping = false;
  constructor(private router: Router, private messageService: MessageService, private appConfigService: AppConfigService, public iomservice: IomService) {
    var url = this.router.url.toLocaleLowerCase();
    if (url.includes('e2euid'))
      this.isFDS = true;
    else
      this.isFDS = false;
    var data = this.appConfigService.getEnvironment();
    this.instanceType = data.instanceType;
  }

  ngOnInit() {   
    this.messageService.currentNavigateToAttributeMapTab.subscribe(msg => (msg == true) ? this.loadAttributeMapp() : "");
    this.messageService.currentNavigateToCreateDDTab.subscribe(msg => (msg == true) ? this.loadTextConf() : "");
    this.messageService.currentNavigateToExcelUploadTab.subscribe(msg => (msg == true) ? this.loadUploadExcel() : "");
    if (this.router.url.startsWith('/createdeepdive')) {      
      if (this.instanceType == 'FDS') {
        if (this.isFDS && this.iomservice.isManualUpload == false)
          this.loadTextConf();
        else
          this.loadUploadExcel();
        return true;
      }
      else {       
          this.isFDS = true;// To Load Pam Version 
          this.loadTextConf();
        }
    }
    else {
      return false;
    }
  }
  showHeaderB() {
    if (this.router.url.startsWith('/editproposal')) {
      return true;
    } else {
      return false;
    }
  }
  fdsStatus() {    
    if (this.router.url.toLocaleLowerCase().includes('e2euid') || this.instanceType != 'FDS')
    {   
    return true;
    }
    else
      return false;      
  }

  hideCreateProp() {
    if (this.router.url.startsWith('/createdeepdive')) {
      return true;
    } else {
      return false;
    }
  }

  loadCreateProposal() {
    this.isLoadCreateProposal = true;
    this.isLoadUploadExcel = false;
    this.isLoadTextConf = false;
    this.isLoadMapping = false;
  }

  loadUploadExcel() {
    this.isLoadCreateProposal = false;
    this.isLoadUploadExcel = true;
    this.isLoadTextConf = false;
    this.isLoadMapping = false;
  }

  loadTextConf() {
    this.DisableUpload = true;
    this.DisableCreate = true
    this.isLoadCreateProposal = false;
    this.isLoadUploadExcel = false;
    this.isLoadTextConf = true;
    this.isLoadMapping = false;
  }
  loadAttributeMapp() {    
    this.DisableUpload = true;
    this.DisableCreate = true
    this.isLoadCreateProposal = false;
    this.isLoadUploadExcel = false;
    this.isLoadTextConf = false;
    this.isLoadMapping = true;
  }
}
